export enum SocketMessageMethods {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  INFO = 'info',
}

interface ISocketMessage {
  method: SocketMessageMethods;
  data: Record<string, unknown>;
}

export default ISocketMessage;
